import { render } from "./SongManagement.vue?vue&type=template&id=67b8bb6e&scoped=true"
import script from "./SongManagement.vue?vue&type=script&lang=js"
export * from "./SongManagement.vue?vue&type=script&lang=js"

import "./SongManagement.vue?vue&type=style&index=0&id=67b8bb6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b8bb6e"]])

export default __exports__